<template>
  <div class="data_tabs">
    <a-tabs type="card" style="background: #ffffff">
      <a-tab-pane key="1" tab="资产详情信息">
        <asset-detail ref="assetDetail" :model="model"></asset-detail>
      </a-tab-pane>
      <a-tab-pane key="2" tab="资产价值">
        <asset-worth ref="assetWorth" :model="model"></asset-worth>
      </a-tab-pane>
      <a-tab-pane key="3" tab="关联设备">
        <associate-device ref="associateDevice" :model="model" :subcompanyid="subcompanyid"></associate-device>
      </a-tab-pane>
      <a-tab-pane key="4" tab="附件管理">
        <accessory-management ref="accessoryManagement"></accessory-management>
      </a-tab-pane>
      <a-tab-pane key="5" tab="资产流程">
        <asset-flow ref="assetFlow" :model="model"></asset-flow>
      </a-tab-pane>
      <a-tab-pane key="6" tab="在建工程信息" v-if="(model && model.txk20) ? model.txk20 === '在建工程- 一般在建工程' || model.txk20 === '在建工程-迁建在建工程' : false">
        <asset-engineering-detail :model="model" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import AssetDetail from './assetDetail.vue'
import AssetFlow from './assetFlow.vue'
import AssetWorth from './assetWorth.vue'
import AssociateDevice from './associateDevice.vue'
import AssetEngineeringDetail from './assetEngineeringDetail.vue'
import AccessoryManagement from './accessoryManagement.vue'
export default {
  props: {
    model: Object,
    subcompanyid: Number || String,
  },
  components: {
    AssetDetail,
    AssetWorth,
    AssociateDevice,
    AssetFlow,
    AssetEngineeringDetail,
    AccessoryManagement
  },
  data  () {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.data_tabs {
  border-top: 1px solid #DDDDDD;
  border-bottom: 1px solid #DDDDDD;
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      //border-bottom: 1px solid #DDDDDD;
      // 线颜色修改
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: #F5F5F5;
      }
      .ant-tabs-tab-active {
        color: #1791FF;
        background: rgba(23, 145, 255, 0.1);
      }
    }
  }

  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>